var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignBranding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theme-transition",
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "theme-tranistion",
    clipPath: "url(#clip0_1_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 124.082C101.094 161.371 150.829 161.295 193 123.918C150.912 86.6345 101.177 86.699 59 124.082ZM150.709 124.475C150.709 137.848 139.859 148.688 126.475 148.688C113.091 148.688 102.241 137.848 102.241 124.475C102.241 111.102 113.091 100.262 126.475 100.262C139.859 100.262 150.709 111.102 150.709 124.475Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 124,
    stroke: "#757572",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignBranding);
export default __webpack_public_path__ + "static/media/DesignBranding.ecfb6357fbb55f6ef6ba41a8de3db1bb.svg";
export { ForwardRef as ReactComponent };